import { computed } from 'vue'
import { useStore } from 'vuex'

/**
 * The customer list a view should render for the logged-in user.
 *
 * Normal users: their own Firestore-denormalized customers_mcs[].
 * PORTAL_SUPER_ADMIN: the single customer picked in the portal-admin picker
 * (entries share the exact customers_mcs element shape), or [] until picked.
 */
export function useEffectiveCustomers() {
    const store = useStore()
    const isPortalSuperAdmin = computed(() => store.getters.isPortalSuperAdmin)
    const customersMcs = computed(() => {
        if (isPortalSuperAdmin.value) {
            const selected = store.state.portalAdminCustomer
            return selected ? [selected] : []
        }
        return store.state.userProfile?.customers_mcs || []
    })
    return { isPortalSuperAdmin, customersMcs }
}
